import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vShow as _vShow, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/images/cod-logo.png'
import _imports_1 from '@/app/ui/assets/images/dfod-logo.png'
import _imports_2 from '@/app/ui/assets/images/prioritas.webp'

const _withId = /*#__PURE__*/_withScopeId("data-v-47b7ae3a")

_pushScopeId("data-v-47b7ae3a")
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "flex flex-row items-center gap-x-3" }
const _hoisted_3 = { class: "w-full sm:w-350px" }
const _hoisted_4 = {
  key: 1,
  class: "empty-state h-full"
}
const _hoisted_5 = {
  key: 3,
  class: "w-full flex flex-col pt-8"
}
const _hoisted_6 = {
  key: 4,
  class: "py-4 sticky bg-white"
}
const _hoisted_7 = { class: "flex flex-row justify-between items-center" }
const _hoisted_8 = { class: "flex flex-row items-center justify-center" }
const _hoisted_9 = {
  key: 0,
  class: "text-16px font-semibold font-montserrat text-gray-lp-300"
}
const _hoisted_10 = {
  key: 1,
  class: "text-12px text-gray-lp-800 font-montserrat font-medium"
}
const _hoisted_11 = { class: "flex flex-col md:flex-row justify-center items-center ml-3 gap-x-1" }
const _hoisted_12 = {
  key: 1,
  src: _imports_0,
  class: "w-auto h-10",
  alt: "cod-logo"
}
const _hoisted_13 = {
  key: 2,
  src: _imports_1,
  class: "w-auto h-10",
  alt: "dfod-logo"
}
const _hoisted_14 = {
  key: 3,
  src: _imports_2,
  class: "w-auto h-6",
  alt: "prioritas-logo"
}
const _hoisted_15 = {
  key: 0,
  class: "relabel-chips ml-4"
}
const _hoisted_16 = {
  key: 0,
  class: "flex flex-row items-center gap-x-3"
}
const _hoisted_17 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_18 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_19 = { class: "flex flex-col w-full" }
const _hoisted_20 = { class: "text-14px font-montserrat font-semibold" }
const _hoisted_21 = { class: "text-14px font-montserrat font-normal pt-1" }
const _hoisted_22 = { class: "text-14px font-montserrat font-semibold" }
const _hoisted_23 = { class: "text-14px font-montserrat font-normal pt-1" }
const _hoisted_24 = { class: "text-14px font-montserrat font-semibold" }
const _hoisted_25 = { class: "max-w-max" }
const _hoisted_26 = { class: "text-14px font-montserrat font-semibold" }
const _hoisted_27 = { class: "max-w-max" }
const _hoisted_28 = { class: "text-14px font-montserrat font-semibold" }
const _hoisted_29 = { class: "flex flex-row items-center" }
const _hoisted_30 = { class: "rounded-2xl font-semibold bg-gray-lp-200 px-2 py-0" }
const _hoisted_31 = { class: "text-14px font-montserrat font-medium items-center whitespace-nowrap pt-1" }
const _hoisted_32 = { class: "text-14px font-montserrat font-semibold" }
const _hoisted_33 = { class: "text-14px font-montserrat font-normal pt-1" }
const _hoisted_34 = { class: "text-14px font-montserrat font-semibold" }
const _hoisted_35 = { class: "text-14px font-montserrat font-normal pt-1" }
const _hoisted_36 = {
  key: 2,
  class: "flex flex-col pt-3 pl-2 max-w-max",
  style: {"margin-left":"auto"}
}
const _hoisted_37 = { class: "grid grid-rows-2 grid-flow-col gap-4 mt-4 md:py-6 md:px-8" }
const _hoisted_38 = { key: 0 }
const _hoisted_39 = /*#__PURE__*/_createTextVNode(" - ")
const _hoisted_40 = { key: 0 }
const _hoisted_41 = /*#__PURE__*/_createTextVNode(" - ")
const _hoisted_42 = { class: "flex justify-end border-t border-gray-lp-400" }
const _hoisted_43 = {
  key: 0,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "w-4 ml-2"
}
const _hoisted_44 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M11.9646 9.07133L8.5946 5.75533C8.26527 5.43133 7.7326 5.43133 7.40326 5.75533L4.0346 9.07133C3.70526 9.39466 3.70526 9.91933 4.0346 10.2433C4.3626 10.5673 4.8966 10.5673 5.2246 10.2433L7.99993 7.514L10.7733 10.2433C11.1026 10.5673 11.6353 10.5673 11.9646 10.2433C12.1286 10.082 12.2106 9.86933 12.2106 9.65733C12.2106 9.44533 12.1286 9.23266 11.9646 9.07133Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_45 = {
  key: 1,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "w-4 ml-2"
}
const _hoisted_46 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M11.9639 5.75466C11.6359 5.43066 11.1019 5.43066 10.7739 5.75466L7.99924 8.48399L5.22591 5.75466C4.89657 5.43066 4.36391 5.43066 4.03457 5.75466C3.87057 5.91666 3.78857 6.12866 3.78857 6.34066C3.78857 6.55266 3.87057 6.76532 4.03457 6.92666L7.40457 10.2427C7.73391 10.5667 8.26657 10.5667 8.59591 10.2427L11.9646 6.92666C12.2932 6.60332 12.2932 6.07866 11.9639 5.75466Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_47 = {
  key: 5,
  class: "flex flex-col mt-3 gap-y-5"
}
const _hoisted_48 = { key: 0 }
const _hoisted_49 = { class: "text-16px font-bold text-black-lp-300 mb-2" }
const _hoisted_50 = {
  key: 0,
  class: "my-5"
}
const _hoisted_51 = { class: "text-16px font-bold text-black-lp-300 mb-2" }
const _hoisted_52 = {
  key: 0,
  class: "my-5"
}
const _hoisted_53 = {
  key: 6,
  class: "flex flex-row gap-x-3 absolute border border-gray-lp-400 shadow-md p-4 rounded-md items-start bg-white",
  style: {"top":"6rem","right":"2px"}
}
const _hoisted_54 = { class: "flex flex-col gap-y-2 text-12px xxl:text-14px max-w-xs" }
const _hoisted_55 = { class: "text-black-lp-300 font-semibold" }
const _hoisted_56 = { class: "text-gray-lp-600" }
const _hoisted_57 = { class: "hidden" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_lp_input = _resolveComponent("lp-input")!
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_EmptyState = _resolveComponent("EmptyState")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_skeleton = _resolveComponent("skeleton")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!
  const _component_TooltipV2 = _resolveComponent("TooltipV2")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_Timeline = _resolveComponent("Timeline")!
  const _component_Tabs = _resolveComponent("Tabs")!
  const _component_Book = _resolveComponent("Book")!
  const _component_PreviewImage = _resolveComponent("PreviewImage")!
  const _directive_sanitize_html = _resolveDirective("sanitize-html")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", {
      class: ["w-full overflow-y-auto pb-8 relative", {'tracking-height': !_ctx.isForModal}]
    }, [
      (!_ctx.isForModal)
        ? (_openBlock(), _createBlock("div", _hoisted_1, [
            _createVNode("div", {
              class: 
          `mt-8 flex flex-col justify-start gap-1 lg:gap-0 lg:flex-row lg:justify-between lg:items-center ${
            _ctx.showSttDetail && !_ctx.isLoading && !_ctx.isError ? 'border-b pb-6' : ''
          }`
        
            }, [
              _createVNode("div", _hoisted_2, [
                _createVNode("div", _hoisted_3, [
                  _createVNode(_component_lp_input, {
                    placeholder: _ctx.$t('placeholderSTTColumn'),
                    modelValue: _ctx.sttNo,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.sttNo = $event)),
                    onChange: _ctx.handleError,
                    onEnter: _cache[2] || (_cache[2] = ($event: any) => (_ctx.trackStt(_ctx.sttNo))),
                    error: _ctx.isError,
                    disabled: false,
                    errorIcon: false,
                    format: _ctx.formatStt
                  }, null, 8, ["placeholder", "modelValue", "onChange", "error", "format"])
                ]),
                _createVNode(_component_lp_button, {
                  disabled: !_ctx.sttNo,
                  title: _ctx.$t('trackingCargo.buttonTracking'),
                  textColor: "white",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.trackStt(_ctx.sttNo)))
                }, null, 8, ["disabled", "title"])
              ])
            ], 2)
          ]))
        : _createCommentVNode("", true),
      (!_ctx.isLoading && !_ctx.showSttDetail && !_ctx.isError)
        ? (_openBlock(), _createBlock("div", _hoisted_4, [
            _createVNode(_component_EmptyState, {
              customClass: "h-fit",
              customHeaderMessage: _ctx.errorHedearMessage,
              data: _ctx.messageEmptyState
            }, null, 8, ["customHeaderMessage", "data"])
          ]))
        : _createCommentVNode("", true),
      (!_ctx.isLoading && _ctx.isError)
        ? (_openBlock(), _createBlock(_component_ErrorMessage, {
            key: 2,
            errorType: _ctx.errorCause,
            errorImage: _ctx.alertMessage.image,
            errorTitle: _ctx.alertMessage.title,
            errorMessage: _ctx.alertMessage.message
          }, null, 8, ["errorType", "errorImage", "errorTitle", "errorMessage"]))
        : _createCommentVNode("", true),
      (_ctx.isLoading)
        ? (_openBlock(), _createBlock("div", _hoisted_5, [
            _createVNode(_component_skeleton, {
              width: "600px",
              height: "40px"
            }),
            _createVNode(_component_skeleton, {
              class: "mt-10",
              width: "800px",
              height: "40px"
            }),
            _createVNode(_component_skeleton, {
              class: "mt-3",
              width: "700px",
              height: "20px"
            }),
            _createVNode(_component_skeleton, {
              class: "mt-3",
              width: "500px",
              height: "20px"
            }),
            _createVNode(_component_skeleton, {
              class: "mt-3",
              width: "800px",
              height: "20px"
            })
          ]))
        : _createCommentVNode("", true),
      (_ctx.showSttDetail && !_ctx.isLoading && !_ctx.isError)
        ? (_openBlock(), _createBlock("div", _hoisted_6, [
            _createVNode("div", _hoisted_7, [
              _createVNode("div", _hoisted_8, [
                _createVNode("div", {
                  class: ["flex flex-col", {'gap-1': _ctx.isForModal}]
                }, [
                  _createVNode("p", {
                    class: ["font-semibold font-montserrat text-gray-lp-300", {'text-xl': _ctx.isForModal, 'text-2xl': !_ctx.isForModal}]
                  }, _toDisplayString(!_ctx.isSttNumber ? _ctx.sttNoCache : _ctx.sttDetail.sttNo), 3),
                  (!_ctx.isSttNumber && _ctx.sttDetail.sttNo)
                    ? (_openBlock(), _createBlock("p", _hoisted_9, _toDisplayString(_ctx.sttDetail.sttNo), 1))
                    : _createCommentVNode("", true),
                  (!_ctx.isShipmentAndNotBookedGenesis)
                    ? (_openBlock(), _createBlock("p", _hoisted_10, " Dibooking : " + _toDisplayString(_ctx.getBookingDateAndTimezone()) + ". ", 1))
                    : _createCommentVNode("", true)
                ], 2),
                _createVNode("div", _hoisted_11, [
                  (_ctx.sttDetail.sttId != 0)
                    ? (_openBlock(), _createBlock("img", {
                        key: 0,
                        src: 
                require(`@/app/ui/assets/svg/product-logo/${_ctx.sttDetail.productType.toLowerCase()}-active.svg`)
              ,
                        class: "w-100px h-12",
                        alt: _ctx.type
                      }, null, 8, ["src", "alt"]))
                    : _createCommentVNode("", true),
                  (_ctx.sttDetail.sttIsCod && !_ctx.sttDetail.sttIsDfod)
                    ? (_openBlock(), _createBlock("img", _hoisted_12))
                    : _createCommentVNode("", true),
                  (_ctx.sttDetail.sttIsCod && _ctx.sttDetail.sttIsDfod)
                    ? (_openBlock(), _createBlock("img", _hoisted_13))
                    : _createCommentVNode("", true),
                  (_ctx.sttDetail.isPriority)
                    ? (_openBlock(), _createBlock("img", _hoisted_14))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.sttDetail.sttNeedToRelabel)
                  ? (_openBlock(), _createBlock("div", _hoisted_15, "Perlu relabel"))
                  : _createCommentVNode("", true)
              ]),
              (!_ctx.isSenderAccount && !_ctx.isForModal)
                ? (_openBlock(), _createBlock("div", _hoisted_16, [
                    (!_ctx.isShipmentAndNotBookedGenesis)
                      ? (_openBlock(), _createBlock(_component_lp_button, {
                          key: 0,
                          disabled: !_ctx.showSttDetail,
                          onClick: _ctx.togglePanelPrint,
                          title: _ctx.$t('trackingCargo.buttonPrintReceipt'),
                          "text-color": "white",
                          icon: 
              _ctx.isPanelPrintVisible
                ? `chevron-up-${_ctx.showSttDetail ? 'white' : 'disable'}`
                : `chevron-down-${_ctx.showSttDetail ? 'white' : 'disable'}`
            
                        }, null, 8, ["disabled", "onClick", "title", "icon"]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_OverlayPanel, {
                      ref: "panelPrint",
                      appendTo: "body",
                      style: {"width":"auto"}
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_LpButton, {
                          onClick: _cache[4] || (_cache[4] = 
                (event) => {
                  _ctx.print('thermal');
                  _ctx.togglePanelPrint(event);
                }
              ),
                          class: "w-60",
                          flat: "",
                          dense: "",
                          iconLeft: "printer",
                          title: "Print Thermal Resi"
                        }),
                        _hoisted_17,
                        _createVNode(_component_LpButton, {
                          onClick: _cache[5] || (_cache[5] = 
                (event) => {
                  _ctx.print('thermal-pdf');
                  _ctx.togglePanelPrint(event);
                }
              ),
                          class: "w-60",
                          flat: "",
                          dense: "",
                          iconLeft: "document-download-outline-grey",
                          title: "Print Thermal Resi PDF"
                        }),
                        _hoisted_18,
                        _createVNode(_component_LpButton, {
                          onClick: _cache[6] || (_cache[6] = 
                (event) => {
                  _ctx.print('basic');
                  _ctx.togglePanelPrint(event);
                }
              ),
                          class: "w-60",
                          flat: "",
                          dense: "",
                          iconLeft: "document-download-outline-grey",
                          title: "Print Basic/Save to PDF"
                        })
                      ]),
                      _: 1
                    }, 512),
                    (
              _ctx.dataProfile && !_ctx.accountIsForeign && !_ctx.isShipmentAndNotBookedGenesis
            )
                      ? (_openBlock(), _createBlock(_component_lp_button, {
                          key: 1,
                          title: "Lapor Kendala",
                          textColor: "red-lp-100",
                          outline: "",
                          onClick: _ctx.toCreatePusatResolusi,
                          disabled: !_ctx.showSttDetail
                        }, null, 8, ["onClick", "disabled"]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createVNode("div", _hoisted_19, [
              _createVNode("div", {
                class: ["py-4 px-4 gap-x-4 flex flex-row mt-4 overflow-scroll md:overflow-hidden", {'justify-between': _ctx.isForModal}],
                style: {"background":"#f5f5f5"}
              }, [
                _createVNode("div", {
                  class: ["flex flex-col gap-y-2 no-stt", [{'no-stt-for-modal': _ctx.isForModal}, {'text-gray-lp-300': _ctx.isForModal}]]
                }, [
                  _createVNode("p", _hoisted_20, " No. STT " + _toDisplayString(_ctx.formattedColumnNameSTT(_ctx.IS_REVERSE_JOURNEY, _ctx.isNewStt)), 1),
                  _createVNode("p", _hoisted_21, _toDisplayString(_ctx.sttDetail.sttNoRef || "-"), 1)
                ], 2),
                _createVNode("div", {
                  class: ["flex flex-col gap-y-2 estimation-date", [{'estimation-date-for-modal': _ctx.isForModal}, {'text-gray-lp-300': _ctx.isForModal}]]
                }, [
                  _createVNode("p", _hoisted_22, _toDisplayString(_ctx.isForModal ? _ctx.$t("trackingCargo.columnsSttDetail.colShipmentTimeForModal") : _ctx.$t("trackingCargo.columnsSttDetail.colShipmentTime")), 1),
                  _createVNode("p", _hoisted_23, _toDisplayString(!_ctx.isSenderAccount
                  ? _ctx.convertEstimationForNonSender(_ctx.sttDetail.estimationsDate)
                  : _ctx.convertEstimationDate(_ctx.sttDetail.estimationsDate)), 1)
                ], 2),
                (!_ctx.isPaid && !_ctx.isShipmentAndNotBookedGenesis)
                  ? (_openBlock(), _createBlock("div", {
                      key: 0,
                      class: ["flex flex-col gap-y-2 status-payment", [{'status-payment-for-modal': _ctx.isForModal}, {'text-gray-lp-300': _ctx.isForModal}]]
                    }, [
                      _createVNode("p", _hoisted_24, _toDisplayString(_ctx.$t("trackingCargo.columnsSttDetail.colStatusPayment")), 1),
                      _withDirectives(_createVNode("div", _hoisted_25, null, 512), [
                        [_directive_sanitize_html, 
                _ctx.onStylingPaymentStatus(_ctx.sttDetail.isPaid, _ctx.sttDetail.shipmentId)
              ]
                      ])
                    ], 2))
                  : _createCommentVNode("", true),
                (_ctx.sttDetail.sttAssessmentStatus)
                  ? (_openBlock(), _createBlock("div", {
                      key: 1,
                      class: ["flex flex-col gap-y-2 status-payment", [{'status-payment-for-modal': _ctx.isForModal}, {'text-gray-lp-300': _ctx.isForModal}]]
                    }, [
                      _createVNode("p", _hoisted_26, _toDisplayString(_ctx.$t("trackingCargo.columnsSttDetail.colAssessmentStatus")), 1),
                      _withDirectives(_createVNode("div", _hoisted_27, null, 512), [
                        [_directive_sanitize_html, 
                _ctx.onStylingAssessmentStatus(_ctx.sttDetail.sttAssessmentStatus)
              ]
                      ])
                    ], 2))
                  : _createCommentVNode("", true),
                _createVNode("div", {
                  class: ["flex flex-col gap-y-2 status-payment", [{'status-payment-for-modal': _ctx.isForModal}, {'text-gray-lp-300': _ctx.isForModal}]]
                }, [
                  _createVNode("p", _hoisted_28, _toDisplayString(_ctx.isForModal ? _ctx.$t("trackingCargo.columnsSttDetail.colCurrentStatusForModal") : _ctx.$t("trackingCargo.columnsSttDetail.colCurrentStatus")), 1),
                  _createVNode("div", _hoisted_29, [
                    _createVNode("div", _hoisted_30, [
                      _createVNode("p", _hoisted_31, _toDisplayString((_ctx.sttDetail.status || _ctx.shipmentHistory?.[0]?.status) ?? ""), 1)
                    ]),
                    _createVNode(_component_TooltipV2, {
                      description: (_ctx.sttDetail.statusLabel || _ctx.shipmentHistory?.[0]?.statusLabel) ?? ''
                    }, null, 8, ["description"])
                  ])
                ], 2),
                _createVNode("div", {
                  class: ["flex flex-col gap-y-2 w-16 total-pieces", [{'total-pieces-for-modal': _ctx.isForModal}, {'text-gray-lp-300': _ctx.isForModal}]]
                }, [
                  _createVNode("p", _hoisted_32, _toDisplayString(_ctx.$t("trackingCargo.columnsSttDetail.colPieces")), 1),
                  _createVNode("p", _hoisted_33, _toDisplayString(_ctx.sttDetail.totalPieces || "-"), 1)
                ], 2),
                _createVNode("div", {
                  class: `flex flex-col gap-y-2 chargeable-weight ${_ctx.isPaid ? 'is-paid' : ''} ${_ctx.isForModal ? 'text-gray-lp-300' : ''}`
                }, [
                  _createVNode("p", _hoisted_34, _toDisplayString(_ctx.$t("trackingCargo.columnsSttDetail.colChargeableWeight")), 1),
                  _createVNode("p", _hoisted_35, _toDisplayString(_ctx.convertDecimalWithComma(_ctx.sttDetail.chargeableWeight) || "-") + " Kg ", 1)
                ], 2),
                (!_ctx.isForModal)
                  ? (_openBlock(), _createBlock("div", _hoisted_36, [
                      (_ctx.showButtonDetailTracking && !_ctx.isShipmentAndNotBookedGenesis)
                        ? (_openBlock(), _createBlock(_component_LpButton, {
                            key: 0,
                            icon: "chevron-right-small",
                            iconV2: "",
                            textColor: "red-lp-100",
                            outline: "",
                            custom: "font-bold",
                            title: _ctx.$t('trackingCargo.buttonShowDetailStt'),
                            onClick: _cache[7] || (_cache[7] = ($event: any) => (
                _ctx.goToDetailShipment(_ctx.isConsole, _ctx.isSubConsole, _ctx.sttDetail.sttId)
              ))
                          }, null, 8, ["title"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ], 2),
              _withDirectives(_createVNode("div", _hoisted_37, [
                _createVNode(_component_DataWrapper, {
                  fontSize: "14",
                  label: _ctx.$t('trackingCargo.sttDetailInfo.detailShipperName'),
                  value: _ctx.sttDetail.senderName,
                  class: "pl-4"
                }, null, 8, ["label", "value"]),
                _createVNode(_component_DataWrapper, {
                  fontSize: "14",
                  label: _ctx.$t('trackingCargo.sttDetailInfo.detailDistrictOriginCity'),
                  value: _ctx.sttDetail.originLocation,
                  class: "pl-4"
                }, null, 8, ["label", "value"]),
                _createVNode(_component_DataWrapper, {
                  fontSize: "14",
                  label: _ctx.$t('trackingCargo.sttDetailInfo.detailRecipientName'),
                  value: _ctx.sttDetail.recipientName,
                  class: "pl-4"
                }, null, 8, ["label", "value"]),
                _createVNode(_component_DataWrapper, {
                  fontSize: "14",
                  label: 
              _ctx.$t('trackingCargo.sttDetailInfo.detailDistrictDestinationCity')
            ,
                  value: _ctx.sttDetail.destinationLocation,
                  class: "pl-4"
                }, null, 8, ["label", "value"]),
                (!_ctx.isSenderAccount && _ctx.sttDetail.bookedName)
                  ? (_openBlock(), _createBlock(_component_DataWrapper, {
                      key: 0,
                      fontSize: "14",
                      label: "Dibooking oleh",
                      class: "pl-4"
                    }, {
                      default: _withId(() => [
                        _createVNode("span", null, [
                          _createTextVNode(_toDisplayString(_ctx.sttDetail.bookedName) + " ", 1),
                          (_ctx.sttDetail.bookedByPhone)
                            ? (_openBlock(), _createBlock("span", _hoisted_38, [
                                _hoisted_39,
                                _createVNode("a", {
                                  href: `https://wa.me/${_ctx.sttDetail.bookedByPhone}`,
                                  target: "_blank",
                                  class: "text-red-lp-300 underline"
                                }, _toDisplayString(_ctx.sttDetail.bookedByPhone), 9, ["href"])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (!_ctx.isSenderAccount && _ctx.sttDetail.name)
                  ? (_openBlock(), _createBlock(_component_DataWrapper, {
                      key: 1,
                      fontSize: "14",
                      label: "Dibooking untuk",
                      class: "pl-4"
                    }, {
                      default: _withId(() => [
                        _createVNode("span", null, [
                          _createTextVNode(_toDisplayString(_ctx.sttDetail.name) + " ", 1),
                          (_ctx.sttDetail.bookedForPhone)
                            ? (_openBlock(), _createBlock("span", _hoisted_40, [
                                _hoisted_41,
                                _createVNode("a", {
                                  href: `https://wa.me/${_ctx.sttDetail.bookedForPhone}`,
                                  target: "_blank",
                                  class: "text-red-lp-300 underline"
                                }, _toDisplayString(_ctx.sttDetail.bookedForPhone), 9, ["href"])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ], 512), [
                [_vShow, _ctx.isFilterShow]
              ]),
              _createVNode("div", _hoisted_42, [
                _createVNode("button", {
                  class: "focus:outline-none flex flex-row items-center text-black-lp-200 text-12px px-4 py-2 mr-6 border-l border-b border-r border-gray-lp-400 rounded-b shadow",
                  onClick: _cache[8] || (_cache[8] = () => _ctx.setFilterShow(!_ctx.isFilterShow))
                }, [
                  _createVNode("div", null, _toDisplayString(_ctx.isFilterShow
                  ? _ctx.$t("trackingCargo.titleToggleFilterOpen")
                  : _ctx.$t("trackingCargo.titleToggleFilterClose")), 1),
                  (_ctx.isFilterShow)
                    ? (_openBlock(), _createBlock("svg", _hoisted_43, [
                        _hoisted_44
                      ]))
                    : (_openBlock(), _createBlock("svg", _hoisted_45, [
                        _hoisted_46
                      ]))
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.showSttDetail && !_ctx.isLoading && !_ctx.isError)
        ? (_openBlock(), _createBlock("div", _hoisted_47, [
            (_ctx.showSttDetail && !_ctx.isLoading && !_ctx.isError)
              ? (_openBlock(), _createBlock("div", _hoisted_48, [
                  (!_ctx.IS_REVERSE_JOURNEY)
                    ? (_openBlock(), _createBlock(_component_Tabs, {
                        key: 0,
                        modelValue: _ctx.activeMenu,
                        data: _ctx.tabHistory,
                        rounded: false,
                        titleSize: 16,
                        marginTop: _ctx.isForModal ? 0 : 6
                      }, {
                        default: _withId(() => [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.trackingList, (tracking, index) => {
                            return (_openBlock(), _createBlock("div", { key: index }, [
                              _createVNode("div", _hoisted_49, _toDisplayString(tracking.date), 1),
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(tracking.items, (item, idx) => {
                                return (_openBlock(), _createBlock("div", { key: idx }, [
                                  _createVNode(_component_Timeline, {
                                    item: item,
                                    time: item.time,
                                    active: index === 0 && idx === 0,
                                    status: item.status,
                                    transitLocation: item.transitLocation,
                                    districtCity: item.location,
                                    description: item.description,
                                    tooltip: item.statusLabel,
                                    proofPod: _ctx.proofPod(item),
                                    proofAdjustBook: _ctx.proofAdjustBook(item),
                                    isVerticalLine: idx < tracking.items?.length - 1,
                                    isHalfVerticalLine: 
                    idx === tracking.items?.length - 1 &&
                      index < _ctx.trackingList?.length - 1
                  ,
                                    internationalTime: item.internationalTime,
                                    onOnClickValue: _ctx.onClickValue
                                  }, null, 8, ["item", "time", "active", "status", "transitLocation", "districtCity", "description", "tooltip", "proofPod", "proofAdjustBook", "isVerticalLine", "isHalfVerticalLine", "internationalTime", "onOnClickValue"])
                                ]))
                              }), 128)),
                              (index < _ctx.trackingList.length - 1)
                                ? (_openBlock(), _createBlock("hr", _hoisted_50))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "data", "marginTop"]))
                    : (_openBlock(), _createBlock(_component_Tabs, {
                        key: 1,
                        modelValue: _ctx.activeMenu,
                        onChange: _ctx.onChangeHistoryTabs,
                        data: _ctx.tabs,
                        rounded: false,
                        titleSize: 16,
                        marginTop: _ctx.isForModal ? 0 : 6
                      }, {
                        default: _withId(() => [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.trackingList, (tracking, index) => {
                            return (_openBlock(), _createBlock("div", { key: index }, [
                              _createVNode("div", _hoisted_51, _toDisplayString(tracking.date), 1),
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(tracking.items, (item, idx) => {
                                return (_openBlock(), _createBlock("div", { key: idx }, [
                                  _createVNode(_component_Timeline, {
                                    item: item,
                                    time: item.time,
                                    active: index === 0 && idx === 0,
                                    status: item.status,
                                    transitLocation: item.transitLocation,
                                    districtCity: item.location,
                                    description: item.description,
                                    tooltip: item.statusLabel,
                                    proofPod: _ctx.proofPod(item),
                                    proofAdjustBook: _ctx.proofAdjustBook(item),
                                    isVerticalLine: idx < tracking.items?.length - 1,
                                    isHalfVerticalLine: 
                    idx === tracking.items?.length - 1 &&
                      index < _ctx.trackingList?.length - 1
                  ,
                                    internationalTime: item.internationalTime,
                                    onOnClickValue: _ctx.onClickValue
                                  }, null, 8, ["item", "time", "active", "status", "transitLocation", "districtCity", "description", "tooltip", "proofPod", "proofAdjustBook", "isVerticalLine", "isHalfVerticalLine", "internationalTime", "onOnClickValue"])
                                ]))
                              }), 128)),
                              (index < _ctx.trackingList.length - 1)
                                ? (_openBlock(), _createBlock("hr", _hoisted_52))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "onChange", "data", "marginTop"]))
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.isShowAlertMessage)
        ? (_openBlock(), _createBlock("div", _hoisted_53, [
            _createVNode("img", {
              src: require('@/app/ui/assets/svg/exclamation-yellow.svg'),
              class: "w-6 max-w-none",
              alt: "warning"
            }, null, 8, ["src"]),
            _createVNode("div", _hoisted_54, [
              _createVNode("p", _hoisted_55, _toDisplayString(_ctx.alertMessage.title), 1),
              _withDirectives(_createVNode("p", _hoisted_56, null, 512), [
                [_directive_sanitize_html, _ctx.alertMessage.message]
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ], 2),
    _createVNode("div", _hoisted_57, [
      _createVNode(_component_Book, { ref: "book" }, null, 512)
    ]),
    (_ctx.showPreviewImage)
      ? (_openBlock(), _createBlock(_component_PreviewImage, {
          key: 0,
          onClose: () => _ctx.actionModalPreview(false),
          data: _ctx.images
        }, null, 8, ["onClose", "data"]))
      : _createCommentVNode("", true)
  ], 64))
})